export default "__VITE_ASSET__CHZrn7iE__"